/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { createAction } from 'redux-actions';
import { createAPIAction } from './api';
import { createTypesMap } from './types';


export const types = createTypesMap('dashboard', [
  'getTimes',
  'getDeveui',
  'getDashboard',
  'getDps',
  'getRefreshCount',
  'getGpsColor',
]);

const getTimes = createAction(types.getTimes, times => times);
const getDeveui = createAction(types.getDeveui, deveuis => deveuis);
const getDps = createAction(types.getDps, dps => dps);
const getRefreshCount = createAction(types.getRefreshCount, count => count);
const getGpsColor = createAction(types.getGpsColor, colors => colors);

function getDashboard(id) {
  return createAPIAction(
    types.getDashboard,
    {
      endpoint: `/lora/dashboards/${id}`,
      method: 'GET',
    },
  )();
}

export default {
  getTimes,
  getDeveui,
  getDashboard,
  getDps,
  getRefreshCount,
  getGpsColor,
};




// WEBPACK FOOTER //
// ./src/redux/actions/dashboard.js